module.exports = __webpack_public_path__ + "img/climate-change.ad7072ea.png";